export enum FeeAmountType {
    FIXED = 'FIXED',
    VARIABLE = 'VARIABLE'
}

export const feeAmountTypeDisplay = {
    [FeeAmountType.FIXED]: 'Fixed',
    [FeeAmountType.VARIABLE]: 'Variable'
};
